/**
 * Labstep
 *
 * @module components/PermaLink/Card/EmptyState
 * @desc Empty state for perma link
 */

import { PermaLinkActionQRScan } from 'labstep-web/components/PermaLink/Action/QRScan';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';
import type { IPermaLinkReaderEmptyStateProps } from './types';

export const PermaLinkReaderEmptyState: React.FC<
  IPermaLinkReaderEmptyStateProps
> = ({ onClick, explanation }) => (
  <CardEmptyState
    src="/img/error/404.svg"
    title="Oops!"
    explanation={
      explanation ||
      'Looks like there are no items associated with this QR Code'
    }
    action={
      <PermaLinkActionQRScan
        actionComponentProps={{
          text: 'Scan Again',
          onClick,
        }}
      />
    }
  />
);
